var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseWarning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login---Setup-pwd---email-Error",
    transform: "translate(-323.000000, -264.000000)",
    stroke: "#FF0000",
    strokeWidth: 0.5,
    fill: "#FF0000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCloseWarning",
    transform: "translate(324.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,19.2 C4.92728571,19.2 0.8,15.0727143 0.8,10 C0.8,4.92728571 4.92728571,0.8 10,0.8 C15.0727143,0.8 19.2,4.92728571 19.2,10 C19.2,15.0727143 15.0727143,19.2 10,19.2 M10,0 C4.47657143,0 0,4.47657143 0,10 C0,15.5234286 4.47657143,20 10,20 C15.5234286,20 20,15.5234286 20,10 C20,4.47657143 15.5234286,0 10,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "13.5462 6.64874286 13.1313429 6.23474286 9.96777143 9.39231429 6.8042 6.23474286 6.3892 6.64874286 9.55277143 9.80631429 6.3892 12.9636 6.8042 13.3776 9.96777143 10.2203143 13.1313429 13.3776 13.5462 12.9636 10.3823429 9.80631429"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWarning);
export default __webpack_public_path__ + "static/media/icCloseWarning.dbc13794efe4e473a82edd01404a598b.svg";
export { ForwardRef as ReactComponent };